<template>
  <div
    v-if="isNoticeVisible"
    class="maintenance-notice"
    :class="{ 'maintenance-notice--hide': isHiddenOnScroll }"
  >
    <div class="maintenance-notice__inner">
      <span class="maintenance-notice__message">
        <template v-if="isMobileView">
          <i class="fas fa-exclamation-triangle"></i> {{ __('maintenance.scheduled_maintenance') }}
          <button @click="openModal" class="button--link button--underline">{{__('buttons.learn_more')}}</button>
        </template>
        <template v-else>
          <span v-html="maintenanceMessage"></span>
        </template>
      </span>
    </div>
  </div>

  <BaseModal
    ref="modalRef"
    width="narrow"
    padding="double"
    titleIcon="fa-exclamation-triangle"
    @close="closeModal"
  >
    <div class="maintenance-notice-modal-wrapper text-align-center">
      <h2>{{ __('maintenance.scheduled_maintenance') }}</h2>
      <span v-html="maintenanceMessage"></span>
    </div>
    <template #footer>
      <div class="button-group">
        <button class="button" @click="closeModal">
          <i class="fas fa-times"></i> {{ __('buttons.close') }}
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import {
  ref, onMounted, onUnmounted, watch,
} from 'vue';
import { useElementSize } from '@vueuse/core';

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
});

const maintenanceMessage = ref(props.message);
const isNoticeVisible = ref(!!props.message);

const isHiddenOnScroll = ref(false);
const isMobileView = ref(false);

const modalRef = ref(null);

const { width: viewportWidth } = useElementSize(document.documentElement);

const handleScrollEvent = () => {
  isHiddenOnScroll.value = window.scrollY > 0;
  if (isHiddenOnScroll.value) {
    document.body.classList.remove('has-maintenance');
  } else if (isNoticeVisible.value) {
    document.body.classList.add('has-maintenance');
  }
};

const openModal = () => {
  modalRef.value.open();
};

const closeModal = () => {
  modalRef.value.close();
};

watch(viewportWidth, (newWidth) => {
  isMobileView.value = newWidth <= 768;
});

onMounted(() => {
  if (isNoticeVisible.value) {
    document.body.classList.add('has-maintenance');
  }
  window.addEventListener('scroll', handleScrollEvent);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollEvent);
});
</script>
